import React from 'react';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import MediaDeviceSelectPill from './MediaDeviceSelectPill';
import {
  DEFAULT_MICROPHONE_ID,
  createStoredPreferenceHelpers,
} from './mediaDeviceSelectorUtils';

export const SESSION_STORAGE_KEY = 'oatrx.portalDelivery.selectedMicrophone';

const {
  defaultPreference,
  readPreference,
  persistPreference,
} = createStoredPreferenceHelpers({
  storageKey: SESSION_STORAGE_KEY,
  fallbackId: DEFAULT_MICROPHONE_ID,
  fallbackLabel: 'Default microphone',
});

export const readStoredMicrophonePreference = readPreference;
export const persistMicrophonePreference = persistPreference;
export { DEFAULT_MICROPHONE_ID };

const MicrophoneSelector = (props) => (
  <MediaDeviceSelectPill
    {...props}
    kind="audioinput"
    fallbackId={DEFAULT_MICROPHONE_ID}
    fallbackLabel={defaultPreference.label}
    pillLabel="Microphone"
    Icon={MicRoundedIcon}
    readPreference={readPreference}
    persistPreference={persistPreference}
  />
);

export default MicrophoneSelector;
